export const animateMirroredImage = (
  tl: gsap.core.Timeline,
  columnRef: HTMLElement,
  topImg: HTMLElement,
  bottomImg: HTMLElement,
  nextReversed: boolean,
) => {
  tl.to(
    columnRef,
    {rotate: nextReversed ? 180 : 0, duration: 0.8, ease: 'power3.inOut'},
    0,
  ) // rotation
    .to(
      topImg,
      {
        opacity: nextReversed ? 0.4 : 1,
        scale: nextReversed ? 0.6 : 1,
        y: nextReversed ? 40 : 0,
        duration: 0.8,
        ease: 'power3.inOut',
      },
      0,
    ) // change topImg opacity and scale (including position)
    .to(
      bottomImg,
      {
        opacity: nextReversed ? 1 : 0.4,
        scale: nextReversed ? 1 : 0.6,
        y: nextReversed ? 0 : -40,
        duration: 0.8,
        ease: 'power3.inOut',
      },
      0,
    ); // change bottomImg opacity and scale (including position)
};
